import { defineStore } from 'pinia';
import http from '@/core/http';

export const storeStore = defineStore('store', {
  actions: {
    // 门店列表
    getListOptions(payload) {
      return http.req_get('/admin/action/getstorelisttodev', { ajax: 1, ...payload });
    },
    // 获取区域位置背景图
    getSeatBgImage(payload) {
      return http.req_post('/admin/action/getareabgimg', { ajax: 1, ...payload });
    },
    // 设置区域位置背景图
    setSeatBgImage(payload) {
      return http.req_post('/admin/action/saveareabgimg', { ajax: 1, ...payload });
    },
  }
});